import { render, staticRenderFns } from "./DeRichTextView.vue?vue&type=template&id=588d10ba&scoped=true&"
import script from "./DeRichTextView.vue?vue&type=script&lang=js&"
export * from "./DeRichTextView.vue?vue&type=script&lang=js&"
import style0 from "./DeRichTextView.vue?vue&type=style&index=0&id=588d10ba&prod&lang=scss&scoped=true&"
import style1 from "./DeRichTextView.vue?vue&type=style&index=1&id=588d10ba&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588d10ba",
  null
  
)

export default component.exports